export default __webpack_public_path__ + "static/bg-icon-75ea36e127f0b266a0b110043a01491d.jpg";